// extracted by mini-css-extract-plugin
module.exports = {"selectedText":"CountryChangeModal_selectedText__wCC3W"};